/*
 Generic event handler to enable pushing events from Alpine to a LiveView socket. Simply include this hook at the top
 level of your page, then call `window.pushEventHook.pushEvent` from any Alpine code to push an event up the socket.
 */
export const PushEvent = {
  mounted() {
    window.pushEventHook = this;
  },
};

export default PushEvent;
